import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-not-library',
    templateUrl: './not-library.component.html',
    styleUrls: ['./not-library.component.scss', '../../../Styles/GlobalStyles.css', '../../../Global/Errors/close-session/close-session.component.scss'],
    standalone: false
})
export class NotLibraryComponent implements OnInit, OnDestroy {

  public router = inject(Router)


  private timerInterval: any;

  ngOnInit(): void {
    this.RedirectTo()
  }

  //-================== FUNCTTION FOR GREETTING ==================-\\

  public GetGreeting(): string {

    let TextGTings: string = '';

    const Date_User = new Date();
    const Hour = Date_User.getHours();

    if (Hour >= 0 && Hour <= 5) {
      TextGTings = 'Buenas noches';
    } else if (Hour >= 6 && Hour <= 11) {
      TextGTings = 'Buenos días';
    } else if (Hour >= 12 && Hour <= 17) {
      TextGTings = 'Buenas tardes';
    } else if (Hour >= 18) {
      TextGTings = 'Buenas noches';
    }

    return TextGTings;
  }

  //-================ FUNCTION FOR NAME USER ================-\\
  public NameUser(): string {
    const Name_User: string = localStorage.getItem('Name_User') || "";
    return (Name_User.split(' ', 2)).join(' ');
  }

  //-================ FUNCTION FOR REDIRECT TO ================-\\
  private RedirectTo(): void {

    Swal.fire({
      toast: true,
      position: 'top-end',
      title: "¡Se te redirigirá al home de la aplicación!",
      html: "Redirigiendo en <b></b> segundos.",
      timer: 10000,
      timerProgressBar: true,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
        const timer = Swal.getPopup()?.querySelector("b");
        this.timerInterval = setInterval(() => {
          if (timer) timer.textContent = `${Math.ceil((Swal.getTimerLeft() || 0) / 1000)}`;
        }, 100);
      },
      willClose: () => {
        clearInterval(this.timerInterval);
      }
    }).then((result) => {
      if (result.dismiss === Swal.DismissReason.timer) {
        this.router.navigate(['/Dashboard/General/HomeSystemCDMS']);
      }
    });
  }

  ngOnDestroy(): void {
    Swal.close();
    clearInterval(this.timerInterval);
  }
}
